import React, { useState } from 'react';
import { Trophy, Crown } from 'lucide-react';
import Compliance from './Compliance';
import Leaderboard from './Leaderboard';

var TABS = [
  { id: 'progress', label: 'Progress', icon: Trophy },
  { id: 'leaderboard', label: 'Leaderboard', icon: Crown },
];

function ProgressHub() {
  var [tab, setTab] = useState('progress');

  return (
    <div className="space-y-6" data-testid="progress-hub">
      <div className="flex gap-1 p-1 bg-white/[0.03] border border-white/[0.06] rounded-xl overflow-x-auto">
        {TABS.map(function (t) {
          var Icon = t.icon;
          return (
            <button key={t.id} onClick={function () { setTab(t.id); }}
              className={'flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-medium transition-all whitespace-nowrap flex-shrink-0 ' +
                (tab === t.id ? 'bg-gradient-to-r from-[#2D2560]/20 to-[#5A4E9E]/20 text-white border border-[#2D2560]/30' : 'text-white/50 hover:text-white/80 hover:bg-white/[0.04]')}
              data-testid={'progress-tab-' + t.id}>
              <Icon className="w-4 h-4" />
              {t.label}
            </button>
          );
        })}
      </div>
      {tab === 'progress' && <Compliance />}
      {tab === 'leaderboard' && <Leaderboard />}
    </div>
  );
}

export default ProgressHub;
